import React from 'react';
import { issueApi } from '../services/api';
import { RegisterItemDetail } from './RegisterItemDetail';

export const IssueDetail: React.FC = () => {
  return (
    <RegisterItemDetail
      kind="issue"
      idParam="id"
      title="Issue"
      iconClass="ri-error-warning-line"
      api={issueApi}
    />
  );
};
